'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _components = require('../../components');

var _urls = require('../../utils/urls');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _AuctioneerAddress = require('./AuctioneerAddress');

var _AuctioneerAddress2 = _interopRequireDefault(_AuctioneerAddress);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _caterwaulComponents = require('@liveauctioneers/caterwaul-components');

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AuctioneerInfo = require('./AuctioneerInfo.scss');

var _AuctioneerInfo2 = _interopRequireDefault(_AuctioneerInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuctioneerInfo = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(AuctioneerInfo, _Component);

    function AuctioneerInfo() {
        (0, _classCallCheck3.default)(this, AuctioneerInfo);
        return (0, _possibleConstructorReturn3.default)(this, (AuctioneerInfo.__proto__ || (0, _getPrototypeOf2.default)(AuctioneerInfo)).apply(this, arguments));
    }

    (0, _createClass3.default)(AuctioneerInfo, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'seller']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                noImageLink = _props.noImageLink,
                seller = _props.seller,
                showSendSellerMessageModal = _props.showSendSellerMessageModal;
            var countryCode = seller.countryCode,
                sellerId = seller.sellerId,
                name = seller.name,
                logoId = seller.logoId;


            var classes = (0, _classnames2.default)(_AuctioneerInfo2.default['auctioneer-info'], className);

            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, (0, _jsx3.default)('div', {
                className: _AuctioneerInfo2.default.details
            }, void 0, (0, _jsx3.default)('div', {
                className: _AuctioneerInfo2.default['flag-name']
            }, void 0, (0, _jsx3.default)(_caterwaulComponents.Flag, {
                className: _AuctioneerInfo2.default.flag,
                countryCode: countryCode
            }), (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getSellerUrl)(sellerId, name),
                className: _AuctioneerInfo2.default.name
            }, void 0, name)), (0, _jsx3.default)(_AuctioneerAddress2.default, {
                seller: seller
            }), (0, _jsx3.default)('div', {
                className: _AuctioneerInfo2.default.question
            }, void 0, (0, _jsx3.default)(_components.ShouldLogInContainer, {
                requireLogin: true,
                requireCompleteProfile: true,
                runFunction: showSendSellerMessageModal
            }, void 0, (0, _jsx3.default)(_components.Link, {}, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'ask_a_question'
            }))), (0, _jsx3.default)('span', {
                className: _AuctioneerInfo2.default['seller-info-pipe']
            }, void 0, '|'), (0, _jsx3.default)(_components.FollowSellerContainer, {
                sellerId: sellerId
            }))), (0, _jsx3.default)('div', {
                className: _AuctioneerInfo2.default['image-container']
            }, void 0, !noImageLink ? (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getSellerUrl)(sellerId, name)
            }, void 0, logoId && (0, _jsx3.default)(_components.ImageWithFallback, {
                className: _AuctioneerInfo2.default.image,
                src: (0, _urls.getAuctioneerLogoUrl)(logoId),
                alt: name
            })) : logoId && (0, _jsx3.default)(_components.ImageWithFallback, {
                className: _AuctioneerInfo2.default.image,
                src: (0, _urls.getAuctioneerLogoUrl)(logoId),
                alt: name
            })));
        }
    }]);
    return AuctioneerInfo;
}(_react.Component), _class.defaultProps = {
    className: ''
}, _temp);
exports.default = AuctioneerInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AuctioneerInfo/AuctioneerInfo.js
// module id = vwV8
// module chunks = 57